import { featuresData } from '@/mocks/home';

export default function Features() {
  return (
    <section id="features" className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-50" aria-labelledby="features-heading">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 id="features-heading" className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-4">
            全方位人脉管理，一站解决
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            六大核心功能，覆盖人脉管理的每一个环节，让您从容应对一切关系场景
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuresData.map((feature) => (
            <div
              key={feature.id}
              className="group bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-7 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-md bg-accent-100 text-accent-600 mb-5 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-lg font-semibold font-heading text-foreground-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}